/**
 * Creates and returns a function that will limit the value of any provided number to within the
 * configured range.
 *
 * @param min The minimum permitted value.
 * @param max The maximum permitted value.
 */

const clamp =
    (min: number, max: number) =>
    (num: number): number =>
        Math.min(max, Math.max(min, num));

export default clamp;
